import { TableOfContents } from '@/lib/types';

import { slug } from '@/utils/slug-utils';

type LinkedSectionProps = {
  component: ComponentWithTableOfContents;
  children: React.ReactNode;
};

export type ComponentWithTableOfContents = {
  id: string;
  tableOfContents?: TableOfContents | null;
};

export default function LinkedSection(props: LinkedSectionProps) {
  const id = linkedSectionID(props.component);
  return (
    <section id={id} className='mb-5 scroll-mt-2'>
      {props.children}
    </section>
  );
}

export function linkedSectionID(component: ComponentWithTableOfContents) {
  const title = component.tableOfContents?.title;
  return title ? slug(title) : component.id;
}
